import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import withAuthorization from '../../hoc/withAuthorization';
import LargePaper from '../../components/Layout/LargePaper';
import { getUsers } from '../../store/users/actions';
import Account from '../../components/Account/Account';
import AccountOptions from '../../components/Account/AccountOptions';
import stylesDefault from '../../constants/stylesDefault';
import Loader from '../../components/Layout/Loader';

export class AccountPage extends Component {
  static propTypes = {
    authUser: PropTypes.object,
    users: (PropTypes.object || PropTypes.array),
  };

  state = {};

  static getDerivedStateFromProps(props) {
    let newState = null;
    if (!props.users && !props.pending) {
      props.getUsers();
    }
    return newState;
  }

  render() {
    const { authUser, users, pending } = this.props;
    const userInfo = users ? users[authUser.uid] : null;
    return (
      <LargePaper>
        <h1 style={stylesDefault.title}>Mon compte</h1>
        {(authUser && userInfo && !pending) ?
          <div>
            <Account userInfo={userInfo}/>
            <AccountOptions/>
          </div>
          :
          <Loader/>
        }
      </LargePaper>);
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    pending: state.users.pending,
    users: state.users.content,
  };
}

const authCondition = authUser => !!authUser;

export default compose(
  withAuthorization(authCondition),
  connect(mapStateToProps, { getUsers }),
)(AccountPage);



// WEBPACK FOOTER //
// ./src/containers/AccountPage/AccountPage.jsx